import { createApp } from 'vue'
import App from './App.vue'
import './styles.css'
import './interface.css'

createApp(App).mount('#vue-app')
